export const historyData = [
    {
      month: "may",
      content: [
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:43:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:44:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:45:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:46:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:47:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:48:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
      ],
    },
    {
      month: "june",
      content: [
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:43:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:44:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:45:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:46:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:47:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:48:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
      ],
    },
    {
      month: "july",
      content: [
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:43:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:44:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:45:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:46:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:47:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:48:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
      ],
    },
    {
      month: "Augt",
      content: [
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:43:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:44:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:45:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:46:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:47:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
        {
          company: "Jp $ CO Corp",
          payment: "#80,000",
          time: "04:48:34",
          date: "03-may-2023",
          percentOff: "25%",
          takeHome: "64,000",
        },
      ],
    },
  ]


  export const appData = [
      {
        Name: "Yusuf",
        Description: "Frontend development",
        DateOfApp: "03-may-2023",
        TimeOfApp: "04:43:34",
        Phoone: "+2348123280394",
        Remark: "Not compatible",
      },
      {
        Name: "Yusuf",
        Description: "Frontend development",
        DateOfApp: "03-may-2023",
        TimeOfApp: "04:43:34",
        Phoone: "+2348123280394",
        Remark: "compatible",
      },
      {
        Name: "Yusuf",
        Description: "Frontend development",
        DateOfApp: "03-may-2023",
        TimeOfApp: "04:43:34",
        Phoone: "+2348123280394",
        Remark: "compatible",
      },
      {
        Name: "Yusuf",
        Description: "Frontend development",
        DateOfApp: "03-may-2023",
        TimeOfApp: "04:43:34",
        Phoone: "+2348123280394",
        Remark: "Average",
      },
      {
        Name: "Yusuf",
        Description: "Frontend development",
        DateOfApp: "03-may-2023",
        TimeOfApp: "04:43:34",
        Phoone: "+2348123280394",
        Remark: "Not conpatible",
      },
      {
        Name: "Yusuf",
        Description: "Frontend development",
        DateOfApp: "03-may-2023",
        TimeOfApp: "04:43:34",
        Phoone: "+2348123280394",
        Remark: "compatible",
      },
      {
        Name: "Yusuf",
        Description: "Frontend development",
        DateOfApp: "03-may-2023",
        TimeOfApp: "04:43:34",
        Phoone: "+2348123280394",
        Remark: "average",
      },
      {
        Name: "Yusuf",
        Description: "Frontend development",
        DateOfApp: "03-may-2023",
        TimeOfApp: "04:43:34",
        Phoone: "+2348123280394",
        Remark: "compatible",
      },
      {
        Name: "Yusuf",
        Description: "Frontend development",
        DateOfApp: "03-may-2023",
        TimeOfApp: "04:43:34",
        Phoone: "+2348123280394",
        Remark: "Not compatible",
      },
      {
        Name: "Yusuf",
        Description: "Frontend development",
        DateOfApp: "03-may-2023",
        TimeOfApp: "04:43:34",
        Phoone: "+2348123280394",
        Remark: "conpatible",
      },
    ]


  export const jobCategories = ["Live in", "Holiday", "Part time", "Full time", "Weekend", "Hybrid", "Shift work", "Summer", "Remote", "Contract", "Contract", "Accomodation", "Intermediate", "Expert", "Joint"]

  export const paymentHistory = [
    {
      applicantName:"Adewale yusuf",
      position:"PHP developer",
      dateOfEmployment: '12-01-2024',
    },
    {
      applicantName:"Adewale yusuf",
      position:"PHP developer",
      dateOfEmployment: "12-02-2024",
    },
    {
      applicantName:"Adewale yusuf",
      position:"PHP developer",
      dateOfEmployment: "12-03-2024",
    },
    {
      applicantName:"Adewale yusuf",
      position:"PHP developer",
      dateOfEmployment: "12-04-2024",
    },
  ]


  export const blacklistedUsers = [
    {
      Fullname:"Aina Shina",
      email:"adewale@gmail.com",
      reports: [
        'lateness to work premises',
        'poor sense of dressing',
        'uncultured manner of approach'
      ],
    },
    {
      Fullname:"Bola Ibu",
      email:"adewale@gmail.com",
      reports: [
        'lateness to work premises',
        'poor sense of dressing',
        'uncultured manner of approach'
      ],
    },
    {
      Fullname:"Wahab Waqas",
      email:"adewale@gmail.com",
      reports: [
        'lateness to work premises',
        'poor sense of dressing',
        'uncultured manner of approach'
      ],
    },
    {
      Fullname:"Jinadu Elewele",
      email:"adewale@gmail.com",
      reports: [
        'lateness to work premises',
        'poor sense of dressing',
        'uncultured manner of approach'
      ],
    },
    
  ]


  export const blacklistedCompanies = [
    {
      companyName:"Golden Gills",
      companyAddress:"21, Golden gate estate Igando, Lago",
      reports: [
        'late salary payment',
        'poor treatment of workers',
        'unsafe act and unsafe working conditions'
      ],
    },
    {
      companyName:"Golden Feather",
      companyAddress:"21, Golden gate estate Igando, Lago",
      reports: [
        'late salary payment',
        'poor treatment of workers',
        'unsafe act and unsafe working conditions'
      ],
    },
    {
      companyName:"Golden Horn",
      companyAddress:"21, Golden gate estate Igando, Lago",
      reports: [
        'late salary payment',
        'poor treatment of workers',
        'unsafe act and unsafe working conditions'
      ],
    },
    {
      companyName:"Golden Beak",
      companyAddress:"21, Golden gate estate Igando, Lago",
      reports: [
        'late salary payment',
        'poor treatment of workers',
        'unsafe act and unsafe working conditions'
      ],
    },
  ]

